import { render, staticRenderFns } from "./_RestManifestEditDialog.vue?vue&type=template&id=58701342&"
import script from "./_RestManifestEditDialog.vue?vue&type=script&lang=js&"
export * from "./_RestManifestEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports